import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1402188a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "manageQuestionView" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "bo" }, "管理题目", -1))

import { onMounted, ref, watch, watchEffect } from "vue";
import message from "@arco-design/web-vue/es/message";
import { MyAxios } from "@/plugins/axios";
import { useRouter } from "vue-router";
import moment from "moment-timezone/moment-timezone-utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageQuestionView',
  setup(__props) {

const router = useRouter();
const dataList = ref([]);
const total = ref(0);
const searchParams = ref({
  current: 1,
  pageSize: 10,
});
/**
 * 加载数据
 */
const loadData = async () => {
  await MyAxios.post("/question/list/page", searchParams.value).then((res) => {
    if (res.data.code === 0) {
      dataList.value = res.data.data.records;
      // todo 格式化数据
      dataList.value.map((item) => {
        item.tags = JSON.parse(item.tags);
        item.createTime = timeFormat(item.createTime);
        item.updateTime = timeFormat(item.updateTime);
      });
      total.value = res.data.data.total;
    } else {
      message.error("加载失败：" + res.data.message);
    }
  });
};
onMounted(() => {
  loadData();
});
watchEffect(() => {
  loadData();
});
const changePageNum = (current: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: current,
  };
};
const changePageSize = (pageSize: number) => {
  searchParams.value = {
    ...searchParams.value,
    pageSize: pageSize,
  };
};

/**
 * 更新题目
 * @param record
 */
const doUpdate = (record: any) => {
  router.push({
    path: "/update/question",
    query: {
      id: record.id,
    },
  });
};
const timeFormat = (time: any) => {
  return moment(time).tz("Asia/Shanghai").format("YYYY-MM-DD hh:mm");
};
/**
 * 删除当前题目
 * @param record
 */
const doDelete = async (record: any) => {
  const deleteParams = ref({ id: record.id });
  await MyAxios.post("/question/delete", deleteParams.value).then((res) => {
    if (res.data.code === 0) {
      message.success("删除成功");
      loadData();
    } else {
      message.error("删除失败: " + res.data.message);
    }
  });
};
const columns = [
  {
    title: "Id",
    dataIndex: "id",
  },
  {
    title: "标题",
    dataIndex: "title",
  },
  {
    title: "内容",
    dataIndex: "content",
  },
  {
    title: "标签",
    dataIndex: "tags",
  },
  {
    title: "答案",
    dataIndex: "answer",
  },
  {
    title: "提交数",
    dataIndex: "submitNum",
  },
  {
    title: "通过数",
    dataIndex: "acceptNum",
  },
  {
    title: "判题用例",
    dataIndex: "judgeCase",
  },
  {
    title: "判题配置",
    dataIndex: "judgeConfig",
  },
  {
    title: "UserId",
    dataIndex: "userId",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
  },
  {
    title: "更新时间",
    dataIndex: "updateTime",
  },
  {
    title: "操作",
    slotName: "operate",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_table, {
      class: "bo",
      columns: columns,
      data: dataList.value,
      pagination: {
        showTotal: true,
        pageSize: searchParams.value.pageSize,
        current: searchParams.value.current,
        total: total.value,
        showPageSize: true,
        showJumper: true,
      },
      onPageChange: changePageNum,
      onPageSizeChange: changePageSize
    }, {
      operate: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              status: "success",
              onClick: ($event: any) => (doUpdate(record))
            }, {
              default: _withCtx(() => [
                _createTextVNode("修改")
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_popconfirm, {
              content: "确定删除此题目?",
              type: "warning",
              onOk: ($event: any) => (doDelete(record))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, { status: "danger" }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除")
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onOk"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data", "pagination"])
  ]))
}
}

})